import { Routes } from '@angular/router';

export const PROFILE_ROUTES: Routes = [
  {
    path: 'profile',
    loadChildren: () => import('@usheru-hff/user-profile').then(m => m.UserProfileModule)
  },
  {
    path: 'auth/change-pwd/:token',
    loadChildren: () =>
      import('@usheru-hff/authentication/feature-change-password').then(
        m => m.AuthenticationFeatureChangePasswordModule
      )
  },
  {
    path: 'double-opt-in',
    loadChildren: () =>
      import('@usheru-hff/shared/feature-validation-page').then(m => m.SharedFeatureValidationPageModule)
  }
];
